import React, { PureComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactQuill, { Quill } from 'react-quill';
import ExplodedProductCardEmbed from './ExplodedProductCardEmbed';
import ReviewFocusedProductCardEmbed from './ReviewFocusedProductCardEmbed';
import NonBreakingSpace from './Modules/NonBreakingSpace';
import { Icon } from 'appSrc/components/UI';
import { DL_COLORS } from 'appSrc/utils/constants';
import style from './styles/style.module.css';
import './styles/global.css';

//TODO: update and fix

Quill.register( ExplodedProductCardEmbed );
Quill.register( ReviewFocusedProductCardEmbed );

Quill.register( { 'modules/nbsp-module': NonBreakingSpace } );

var icons = Quill.import( 'ui/icons' );
icons[ 'product' ] = `<i class='icon'>
    <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke-width='.5' fill-rule="evenodd" clip-rule="evenodd" d="M10.5744 3.11795C10.5436 2.91282 10.3692 2.76923 10.1641 2.76923H7.80513V1.80513C7.80513 0.810257 6.99487 0 6 0C5.00513 0 4.19487 0.810257 4.19487 1.80513V2.76923H1.8359C1.63077 2.76923 1.45641 2.91282 1.42564 3.11795L0.0512817 11.4256C0.0307689 11.5487 0.0615381 11.6718 0.143589 11.7641C0.225641 11.8564 0.338461 11.9077 0.461538 11.9077H11.5385H11.5487C11.7846 11.9077 11.9692 11.7231 11.9692 11.4872C11.9692 11.4359 11.959 11.3949 11.9487 11.3539L11.9487 11.3538L10.5744 3.11795ZM5.03588 1.80514C5.03588 1.2718 5.46665 0.841034 5.99998 0.841034C6.53332 0.841034 6.96409 1.2718 6.96409 1.80514V2.76924H5.03588V1.80514ZM2.19486 3.61026L0.953833 11.0769H11.0461L9.80511 3.61026H7.80512V5.95898C7.80512 6.19488 7.6205 6.37949 7.3846 6.37949C7.14871 6.37949 6.96409 6.19488 6.96409 5.95898V3.61026H5.03588V5.95898C5.03588 6.19488 4.85127 6.37949 4.61537 6.37949C4.37947 6.37949 4.19486 6.19488 4.19486 5.95898V3.61026H2.19486Z" fill="currentColor"/>
    </svg>
</i>`;
icons[ 'nbsp' ] = ReactDOMServer.renderToString(
    <Icon source='fontAwesome' icon='fas/faTextWidth' alt='Non-Breaking Space' title='Add Non-Breaking Space' size={ null } />
);



class DLRichTextEditor extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            value: props.value ? props.value : '',
        };
    }
    componentDidMount() {
        const { childRef } = this.props;
        if( childRef ) {
            childRef( this );
        }
        this.setState( { mounted: true } );
    }
    componentWillUnmount() {
        const { childRef } = this.props;
        if( childRef ) {
            childRef( undefined );
        }
    }
    handleChange = ( value, delta, source ) => {
        if( source !== 'api' ) {
            if( !this.props.value ) {
                this.setState( { value: value } );
            }
            this.props.onChange( value );
        }
    }



    render() {
        var value = this.state.value;

        const modules = this.props.modules || {
            toolbar: {
                container: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'link', { 'align': [] } ],
                    [ 'nbsp', { 'color': [ DL_COLORS[ 'text' ], '#979797', '#F2F2F2', DL_COLORS[ 'white' ], DL_COLORS[ 'gold' ], '#7E57C5', '#B557C5', '#5776C5', '#94BF45' ] } ],
                    [ { 'list': 'ordered'}, { 'list': 'bullet' } ],
                    [ 'image' ],
                ],
            },
            'nbsp-module': true,
            clipboard: {
                matchVisual: false,
            },
        };


        return (
            <div className={ style.richTextEditor }
            data-full-width={ this.props.fullWidth }
            data-name={ this.props.name } >
                { this.props.label &&
                    <label style={ this.props.labelStyle }>{ this.props.label }</label>
                }
                <ReactQuill defaultValue={ value }
                modules={ modules }
                ref={ ( rte ) => { this._rte = rte; } }
                placeholder={ this.props.placeholder }
                onChange={ this.handleChange } />
            </div>
        );
    }
}
DLRichTextEditor.defaultProps = {
    onChange: () => {},
};


export default DLRichTextEditor;
